"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INDETERMINATE = exports.NONE = exports.CHORUS = exports.VERSE = void 0;
/**
 * Used to mark a paragraph as verse
 * @constant
 * @type {string}
 */

var VERSE = 'verse';
/**
 * Used to mark a paragraph as chorus
 * @constant
 * @type {string}
 */

exports.VERSE = VERSE;
var CHORUS = 'chorus';
/**
 * Used to mark a paragraph as not containing a line marked with a type
 * @constant
 * @type {string}
 */

exports.CHORUS = CHORUS;
var NONE = 'none';
/**
 * Used to mark a paragraph as containing lines with both verse and chorus type
 * @constant
 * @type {string}
 */

exports.NONE = NONE;
var INDETERMINATE = 'indeterminate';
exports.INDETERMINATE = INDETERMINATE;